export default {
  properties: {
    display_name: {
      type: 'string',
      description: 'display name of the Service ; eg : Free Wifi'
    },
    category: { type: 'string', description: 'Service category' },
    description: { type: 'string', description: 'Service description' },
    logo: {
      type: 'string',
      description: 'Service Logo',
      format: 'binary',
      binaryEncoding: 'base64'
    },
    service_uri: { type: 'string', description: 'Service website' },
    price: { type: 'string', description: 'Service price' },
    location_address: { type: 'string', description: 'Service phone' },
    mall: { type: 'string', description: 'Mall' }
  },
  additionalProperties: false,
  type: 'object',
  title: 'Service',
  description: 'Retailers',
  required: []
};
